import { render } from "./WalletInstructionsModal.vue?vue&type=template&id=90bf95a6&scoped=true"
import script from "./WalletInstructionsModal.vue?vue&type=script&lang=js"
export * from "./WalletInstructionsModal.vue?vue&type=script&lang=js"

import "./WalletInstructionsModal.vue?vue&type=style&index=0&id=90bf95a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90bf95a6"]])

export default __exports__